import type { IconData } from '@stacksjs/iconify-core'

export const musicNoteTrebbleClef: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M16 42a3 3 0 1 0 6 0a3 3 0 1 0-6 0\"/><path d=\"M19 45h2a6 6 0 0 0 6-6v-5m-.5-25q.001-.814.025-1.494C26.615 4.962 28.455 3 31 3c2.519 0 4.375 1.993 4.475 4.51q.024.585.025 1.24c0 3.49-3.268 5.9-6.755 5.792a89 89 0 0 0-3.743-.037C19.435 14.564 15 18.932 15 24.5c0 5.27 4.239 9.305 9.507 9.444c1.292.034 2.642.056 3.993.056c1.384 0 2.632-.023 3.739-.058C36.034 33.819 39 31.047 39 27.25c0-3.76-3.008-6.504-6.766-6.67A75 75 0 0 0 29 20.5c-1.283 0-2.463.051-3.474.121c-2.178.15-4.026 1.696-4.026 3.879c0 2.165 1.872 3.672 4.031 3.838c1.163.09 2.424.162 3.469.162c2.75 0 4-.25 4-.25\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default musicNoteTrebbleClef
